export const MEGABYTE_IN_KILOBYTES = 1024;
